// extracted by mini-css-extract-plugin
export default {"exception":"ExceptionsTab_exception__Apxdy","exceptionBlock":"ExceptionsTab_exceptionBlock__KtFTV","actions":"ExceptionsTab_actions__2hGzs"};